import { render, staticRenderFns } from "./IconRewardMenuMyReward.vue?vue&type=template&id=1cd207bb"
import script from "./IconRewardMenuMyReward.vue?vue&type=script&lang=js"
export * from "./IconRewardMenuMyReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports